import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../Icon';
import usePageMeta from '../usePageMeta';
import { newsDate, newsLink } from '../newsData';
import { mediaUrl } from '../media';
import { useSiteContent } from '../SiteContent';
import T from '../components/EditableText';

const Aktuelles: React.FC = () => {
  const { news } = useSiteContent();

  usePageMeta(
    'Aktuelles aus der Seniorenbetreuung Antczak',
    'Neuigkeiten, Termine und Einblicke aus dem Alltag der Seniorenbetreuung Antczak in Gifhorn — vom Tag der Senioren bis zum neuen Beratungsbüro.',
    { standaloneTitle: true },
  );

  const [featured, ...rest] = news;

  return (
    <>
      {/* Seitenkopf hell und knapp — der neueste Beitrag ist der eigentliche Aufmacher */}
      <section className="shell hx-pagehead">
        <span className="eyebrow">
          <T k="aktuelles.hero.eyebrow" />
        </span>
        <h1 className="h-page">
          <T k="aktuelles.hero.titel" />{' '}
          <span className="accent">
            <T k="aktuelles.hero.titel-akzent" />
          </span>
        </h1>
        <p className="hx-muted-lead">
          <T k="aktuelles.hero.lead" />
        </p>
      </section>

      {/* Neuester Beitrag im Stil des Startseitenkopfs */}
      <section className="shell">
        <Link to={newsLink(featured)} className="hx-hero hx-hero--news">
          <div className="hx-hero__body">
            <span className="eyebrow eyebrow--on-image">
              <T k="aktuelles.neuester.marke" /> · {newsDate(featured)}
            </span>
            <h2 className="h-block hx-hero__title">{featured.title}</h2>
            <p className="hx-hero__lead">{featured.teaser}</p>
            <span className="textlink hx-hero__link">
              <T k="aktuelles.beitrag.link" /> <Icon name="arrow-right" size={16} />
            </span>
          </div>
          <div className="hx-hero__media">
            <img src={mediaUrl(featured.image)} alt={featured.imageAlt} width={900} height={620} />
          </div>
        </Link>
      </section>

      {/* Weitere Beiträge */}
      <section className="shell section">
        <div className="hx-cardgrid hx-cardgrid--3">
          {rest.map((item) => (
            <Link key={item.slug} to={newsLink(item)} className="hx-card hx-card--link">
              <img src={mediaUrl(item.image)} alt={item.imageAlt} width={680} height={440} loading="lazy" />
              <div className="news-tile__date">{newsDate(item)}</div>
              <h2 className="h-card">{item.title}</h2>
              <p>{item.teaser}</p>
            </Link>
          ))}
        </div>
      </section>
    </>
  );
};

export default Aktuelles;
